import React from "react";
import { partnerOffersMedicalTourism } from "./medicalPartnerAdminConstants";

const MedicalPartnerListMtSwitch = ({ rowId, item, disabled, onMtSwitchChange }) => (
  <div className="custom-control custom-switch medical-partner-list__mt-switch">
    <input
      type="checkbox"
      className="custom-control-input"
      id={`partner-list-mt-${rowId}`}
      checked={partnerOffersMedicalTourism(item)}
      disabled={disabled}
      onChange={(e) => onMtSwitchChange(item, e.target.checked)}
      onClick={(e) => e.stopPropagation()}
    />
    <label className="custom-control-label" htmlFor={`partner-list-mt-${rowId}`}>
      <span className="sr-only">Medical tourism enabled</span>
    </label>
  </div>
);

export default MedicalPartnerListMtSwitch;
